/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateCardViewStore } from '../../axios/candidateCardViewStore'
import type {
	CandidateCardViewStoreError,
	CandidateCardViewStorePathParams,
	CandidateCardViewStoreResponse,
} from '../../types/CandidateCardViewStore'

export const candidateCardViewStoreMutationKey = () => [{ url: '/candidates/:candidate/card-views' }] as const

export type CandidateCardViewStoreMutationKey = ReturnType<typeof candidateCardViewStoreMutationKey>

export type CandidateCardViewStoreVariables = {
	candidate: CandidateCardViewStorePathParams['candidate']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateCardViewController.php CandidateCardViewController::store */
export function useCandidateCardViewStore<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateCardViewStoreResponse,
		AxiosError<CandidateCardViewStoreError>,
		CandidateCardViewStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateCardViewStoreMutationKey(),
		mutationFn: ({ candidate }: CandidateCardViewStoreVariables) =>
			candidateCardViewStore(candidate, config).then(res => res.data),
		...options,
	})
}
